import React, {
  useRef,
  useEffect,
  useState,
  useReducer,
  useContext,
} from 'react'
import { useTranslation } from 'react-i18next'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Form, FormElement } from '@progress/kendo-react-form'
import './dialog-sign.css'
import CanvasDraw from '@win11react/react-canvas-draw'
import { PDFDocument } from 'pdf-lib'
import { Document, Page, pdfjs } from 'react-pdf'
import P5Contianer from './P5Contianer'

import { useMediaQuery } from '@material-ui/core'
import { Context } from '../../../Context'
import { getStampTimeAndTimezone, PDFUtil } from '../../../utils'
import { ButtonHLPure, CheckBoxHLPure, FaceRecognition, InstructionsPure, InteractiveDialog, SimpleLoading } from '..'
import { ValidationCodePure } from '../../pures'
import { useWindowDimensions, useScreenOrientation, useCanvasDimensions } from '../../../hooks'
import SignatureUtil from '../../../utils/signature.util'

const initialValuesState = {
  activeOnSubit: false,
  signatureData: {},
}

function valuesReducerActions(state, action) {
  switch (action.type) {
    case 'setActiveOnSubit':
      return { ...state, activeOnSubit: action.data }
    default:
      throw new Error()
  }
}

const DialogAcceptSignatureAutografaCustom = (props) => {
  let {
    step,
    setStep
  } = props
  let signatureImg = props.autographySign
  const { setCanvasData, setShowSignatureCanvas } = useContext(Context)
  let name = props?.currentUserName ?? ""
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`
  const [currentSystem, setCurrentSystem] = useState("")
  const { t } = useTranslation()
  const pad = useRef(null)
  const [pagesSize, setPagesSize] = useState([])
  const [imgSignature, setImgSignature] = useState(null)
  const [widthImgSignature, setWidthImgSignature] = useState(400)
  const [heightImgSignature, setHeightImgSignature] = useState(300)
  const [pagesImgs, setPagesImgs] = useState([])
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(0)
  const [pager, setPager] = useState(1)
  const greyTextRef = useRef(null)
  const [tempImgPages, setTempImgPages] = useState({})
  const [values, dispatchValues] = useReducer(
    valuesReducerActions,
    initialValuesState
  )

  const [showLoading, setShowLoading] = useState(false)

  //Dialog Props
  const [title, setTitle] = useState(props.currentUser.proofOfLife ? t('dialogAcceptSignature.proof-sign.dialog.title') : '')
  const [showAuthorization, setShowAuthorization] = useState(false)
  const [checkedTerms, setCheckedTerms] = useState(false)

  const [tempDimentions, setTempDimentions] = useState({ width: 0, height: 0 })
  const [clicAvailable, setClicAvailable] = useState(false)
  const [nip, setNip] = useState('')
  const [scale, setScale] = useState(1)
  const [sign, setSign] = useState(1)
  const [numSign, setNumSign] = useState(0)
  const [currentSign, setCurrentSign] = useState({})

  const [wasChanged, setWasChanged] = useState(false);
  const mediaRecorderMimeType = process.env.REACT_APP_MEDIA_RECORDER_MIMETYPE
  const blobType = process.env.REACT_APP_BLOB_TYPE

  /** @type {[MediaStream, import('react').Dispatch<MediaStream>]} */
  const [stream, setStream] = useState(null)

  /** @type {[boolean, React.Dispatch<boolean>]} */
  const [proofOfLifeValid, setProofOfLifeValid] = useState(false)

  const [status, setStatus] = useState('waiting')

  const mediaRecorder = useRef(null)
  const canvasRef = useRef(null)
  const chunksRef = useRef([])
  const bufferVideoRef = useRef(null)

  /** @type {Blob} */
  let bufferVideo = new Blob()

  const [imageData, setImageData] = useState(new Blob())

  const changedOrientation = useScreenOrientation()

  const videoRef = useRef(null)
  const cleanInputsRef = useRef(null)

  const { width, height } = useCanvasDimensions()

  const { hasChanged } = useWindowDimensions()

  let coordinates = props.currentUser.coordinates?.data
  let pdfFile =
    'data:application/pdffilename=file.pdfbase64,' + props.signRequestPDF
  let greyText =
    step === 'sign'
      ?
      props.userMultipleSign && props.baseSign
        ? t('dialogAcceptSignature.noticeCreateSignAutografaBase.multipleSigns.with.baseSign')
        : !props.userMultipleSign && props.baseSign
          ? t('dialogAcceptSignature.noticeCreateSignAutografaBase.oneSign.with.baseSign')
          : props.userMultipleSign && !props.baseSign
            ? t('dialogAcceptSignature.noticeCreateSignAutografaBase.multipleSigns.without.baseSign')
            : t('dialogAcceptSignature.noticeCreateSignAutografaBase.oneSign.without.baseSign')
      : ''

  let infodevice = currentSystem.toLowerCase()
  // let isMobile = infodevice.includes('android') || infodevice.includes('')
  // isMobile = isMobile || infodevice.includes('iphone')
  // isMobile = isMobile || infodevice.includes('ipad')
  // isMobile = isMobile || infodevice.includes('mobile')

  const isMobile = useMediaQuery('(max-width: 700px), (max-height: 400px)')
  // const isTouchScreendevice = () =>
  //   'ontouchstart' in window || navigator.maxTouchPoints
  // if (isTouchScreendevice()) isMobile = true
  useEffect(() => {
    const divGreyText = greyTextRef.current
    // if (divGreyText) {
    //   if (divGreyText.clientWidth) {
    //     setdivGreyTextSize(divGreyText.clientWidth)
    //   }
    // }
  }, [props.visibleAccept])

  useEffect(() => {
    let tempArr = [...Array(numPages)]
    for (const key in tempImgPages) {
      tempArr[Number(key)] = tempImgPages[key]
    }
    setPagesImgs(tempArr)
  }, [numPages, tempImgPages])

  const getPdgPageSize = async () => {
    let pdfDoc = await PDFDocument.load(pdfFile)
    const { PDFDocument: pdfReturned } = PDFUtil.fixPageType(pdfDoc)
    pdfDoc = pdfReturned
    const pages = pdfDoc.getPages()
    let sizes = pages.map((i) => i.getSize())
    setPagesSize(sizes)
  }

  const onDocumentLoadSuccess = (params) => {
    setNumPages(params.numPages)
    // setPageNumber(coordinates ? coordinates[sign - 1]?.page : params.numPages)
    // setPageNumber(params.numPages)
    if (props.documentNameToShowInSign && props.documentsPackage && props.documentsPackage.length > 0 && props.documentsPackage[0].groupName === process.env.REACT_APP_DOCUMENT_PROFILE_DEFAULT_GROUPNAME) {
      let coorFind = coordinates.filter(coordinate => coordinate.document === props.documentNameToShowInSign)
      coordinates = coorFind
    }

    setPager(params.numPages)
    setPageNumber(coordinates ? coordinates[sign - 1]?.page : params.numPages)
  }

  const changePageSign = (offset) => {
    setSign(offset)
    if (coordinates[offset - 1].page === pageNumber) {
      return
    } else {
      setTempImgPages('')
      setPageNumber(coordinates[offset - 1].page)
    }
  }

  const gotToEnd = () => {
    let out = document.getElementsByClassName('k-dialog-content')
    // out[0].scrollTop = out[0].scrollHeight * 0.7
  }

  let yPositionCanvas = {
    y1: 205,
    y2: 235,
    y3: 275
  }

  const saveImage = (proofOfLife) => {
    let image
    let destinationCanvas
    if (!proofOfLife) {
      let canvas = document.querySelectorAll('canvas')
      const elements = Array.from(canvas).filter(chapter => !chapter.id.includes('container_annotationCanvas') && !chapter.id.includes('container_pdfviewer'))
      const sourceCanvas = elements[1]

      destinationCanvas = document.createElement('canvas')
      destinationCanvas.height = sourceCanvas.height
      destinationCanvas.width = sourceCanvas.width
      let destinationContext = destinationCanvas.getContext('2d')
      destinationContext.drawImage(sourceCanvas, 0, 0)
      destinationContext.globalCompositeOperation = 'destination-over'
      destinationContext.fillStyle = '#4484a500'
      destinationContext.fillRect(
        0,
        0,
        destinationCanvas.width,
        destinationCanvas.height
      )
      image = destinationCanvas.toDataURL('image/png')
    } else {
      let canvas = document.querySelectorAll('canvas')
      const elements = Array.from(canvas).filter(chapter => !chapter.id.includes('container_annotationCanvas') && !chapter.id.includes('container_pdfviewer'))
      const sourceCanvas = elements[1]
      let sourceSign = elements[2]
      destinationCanvas = document.createElement('canvas')
      destinationCanvas.height = sourceCanvas.height
      destinationCanvas.width = sourceCanvas.width
      let destinationContext = destinationCanvas.getContext('2d')
      destinationContext.drawImage(sourceCanvas, 0, 0)
      destinationContext.drawImage(sourceSign, 0, 0)
      destinationContext.globalCompositeOperation = 'destination-over'
      destinationContext.fillStyle = '#4484a500'
      destinationContext.fillRect(
        0,
        0,
        destinationCanvas.width,
        destinationCanvas.height
      )
      image = destinationCanvas.toDataURL('image/png')
    }
    return {
      newImg: image,
      imageWidth: destinationCanvas.width,
      imageHeight: destinationCanvas.height,
    }
  }

  /**
  * @param {number} y - Posición vertical
  * @param {string} text - Texto a dibujar
  * @param {boolean} isTimestamp 
  */
  function setTextInCanvas(y, text, isTimestamp) {
    try {
      let canvas = document.querySelectorAll('canvas')
      const elements = Array.from(canvas).filter(chapter => !chapter.id.includes('container_annotationCanvas') && !chapter.id.includes('container_pdfviewer'))
      const gottenCanvas = elements[1]

      const ctx = gottenCanvas.getContext('2d')

      ctx.font = 'bold 23px Arial'
      if (isMobile && (changedOrientation === 'portrait-primary' || changedOrientation === 'portrait-secondary')) ctx.font = 'bold 13px Arial'
      else if (isMobile && (changedOrientation === 'landscape-primary' || changedOrientation === 'landscape-secondary')) ctx.font = 'bold 19px Arial'

      if (isTimestamp && isMobile) {
        switch (changedOrientation) {
          case 'landscape-primary':
          case 'landscape-secondary':
            y += 20
            break
        }
      }

      if (isTimestamp && !isMobile) y += 10
      else if (props.baseSign && isTimestamp && isMobile) y += -7.5
      else if (!props.baseSign && isTimestamp && isMobile) y += 0
      // if (!signatureImg && isTimestamp && !isMobile) y += 5

      ctx.textAlign = 'center'
      ctx.fillText(text, gottenCanvas.width / 2, y, gottenCanvas.width)
    } catch (error) { }
  }

  /**
   * @param {string} img
   * @return {Promise<{width: number, height: number}>} 
   */
  async function setImageInCanvas(img) {
    const image = new Image()
    image.src = img

    try {
      let canvas = document.querySelectorAll('canvas')
      const elements = Array.from(canvas).filter(chapter => !chapter.id.includes('container_annotationCanvas') && !chapter.id.includes('container_pdfviewer'))
      const sourceCanvas = elements[1]

      let ctx = sourceCanvas.getContext('2d')
      let height = sourceCanvas.height
      let width = sourceCanvas.width
      return new Promise((res, rej) => {
        image.onload = () => {
          if (image.height < SignatureUtil.MAX_HEIGHT || image.width < SignatureUtil.MAX_WIDTH) height += 5
          ctx.drawImage(
            image,
            0,
            0,
            width,
            height
          )
          res({ width, height })
        }
      })
    } catch (error) {
    }
  }

  function adjustYCoordinates() {
    let canvas = document.querySelectorAll('canvas')
    const elements = Array.from(canvas).filter(chapter => !chapter.id.includes('container_annotationCanvas') && !chapter.id.includes('container_pdfviewer'))
    const gottenCanvas = elements[1]

    if (changedOrientation === 'portrait-primary' || changedOrientation === 'portrait-secondary') {
      if (gottenCanvas.height >= 300) yPositionCanvas = {
        y1: gottenCanvas.height - 80,
        y2: gottenCanvas.height - 60,
        y3: gottenCanvas.height - 40
      }
      else yPositionCanvas = {
        y1: gottenCanvas.height - 40,
        y2: gottenCanvas.height - 27.5,
        y3: gottenCanvas.height - 10
      }
    } else if (changedOrientation === 'landscape-primary' || changedOrientation === 'landscape-secondary')
      yPositionCanvas = {
        y1: gottenCanvas.height - 80,
        y2: gottenCanvas.height - 60,
        y3: gottenCanvas.height - 40
      }
  }
  /**
   * @param {string} firstName
   * @param {string} lastName
   */
  function setNamesInCanvas(firstName, lastName) {
    adjustYCoordinates()

    if (firstName.length + lastName.length > 26) {
      setTextInCanvas(yPositionCanvas.y1, `${firstName}`)
      setTextInCanvas(yPositionCanvas.y2, `${lastName}`)
    } else {
      setTextInCanvas(yPositionCanvas.y2, `${firstName} ${lastName}`)
    }
  }

  const keyDown = (e) => {
    if (e.key === 'Enter') {
      if (sign === '' || sign === 0) {
        return
      }
      changePageSign(sign)
    } else if (e.key === 'Backspace') {
      setSign('')
    } else if (e.key === '0') {
      setSign(0)
    } else if (typeof Number(e.key) === 'number' && Number(e.key) > 0) {
      if (Number(e.key) < coordinates.length) {
        setSign(Number(e.key))
      } else {
        setSign(coordinates.length)
      }
    }
  }

  // const updateDimensions = () => {
  //   if (pad.current) {
  //     const containerWidth = pad.current.canvasContainer.clientWidth
  //     const aspectRatio = 300 / 627 // Relación de aspecto (alto/ancho)
  //     const newHeight = containerWidth * aspectRatio
  //   }
  // }

  /**
   * @param {MediaStream} streamData
   * @param {Blob} imgData
   */
  const startRecording = async (streamData, imgData) => {
    if (mediaRecorder.current) return
    setStream(streamData)
    setImageData(imgData)

    // Detección de mimeType soportado (iOS fallback)
    const candidateTypes = [
      mediaRecorderMimeType,
      'video/mp4;codecs=h264,opus',
      'video/mp4',
      'video/webm;codecs=vp9,opus',
      'video/webm'
    ].filter(Boolean)

    let chosenType = ''
    for (const type of candidateTypes) {
      if (MediaRecorder.isTypeSupported(type)) {
        chosenType = type
        break
      }
    }

    const options = chosenType ? { mimeType: chosenType } : undefined
    try {
      const media = new MediaRecorder(streamData, options)
      mediaRecorder.current = media
    } catch (e) {
      console.error('MediaRecorder init failed, retrying without mimeType', e)
      mediaRecorder.current = new MediaRecorder(streamData)
    }

    chunksRef.current = []
    mediaRecorder.current.ondataavailable = (event) => {
      if (event.data && event.data.size > 0) {
        chunksRef.current.push(event.data)
      }
    }
    mediaRecorder.current.start()
  }

  const stopRecording = async () => {
    if (!mediaRecorder.current) return null

    if (mediaRecorder.current.state === 'inactive') {
      return bufferVideoRef.current
    }
    return new Promise((resolve, reject) => {
      mediaRecorder.current.onstop = () => {
        try {
          const blob = new Blob(chunksRef.current, { type: blobType || chunksRef.current[0]?.type || 'video/mp4' })
          bufferVideoRef.current = blob
          chunksRef.current = []
          // Detener tracks con seguridad
          stream.getTracks().forEach(t => t.stop())
          if (videoRef.current && videoRef.current.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(t => t.stop())
          }
          setStream(null)

          mediaRecorder.current = null
          resolve(blob)
        } catch (e) {
          console.warn('onstop error', e)
          reject(e)
        }
      }
      try {
        mediaRecorder.current.stop()
      } catch (e) {
        console.warn('stop() error', e)
        resolve(bufferVideoRef.current)
      }
    })
  }

  const cancelRecording = () => {
    if (stream) {
      stream.getTracks().forEach(track => track.stop())
      setStream(null)
    }
    if (videoRef.current && videoRef.current.srcObject) {
      videoRef.current.srcObject.getTracks().forEach(track => track.stop())
    }
    if (mediaRecorder.current) {
      mediaRecorder.current.stop()
      mediaRecorder.current.onstop = () => {
        //creates a playable URL from the blob file.
        chunksRef.current = []
        mediaRecorder.current = null
      }
    }
    setProofOfLifeValid(false)
  }

  const previousSign = () => {
    if (sign <= 1) return
    changePageSign(sign - 1)
  }

  const nextSign = () => {
    if (sign >= numSign) return
    changePageSign(sign + 1)
  }


  useEffect(() => {
    setNumSign(coordinates?.length)
    if (coordinates?.length >= 1) {
      setSign(1)
    }
  }, [coordinates])

  useEffect(() => {
    if (sign > numSign) {
      setSign(1)
    }
  }, [sign])

  useEffect(() => {
    setCurrentSystem(navigator.userAgent)
  }, [])

  useEffect(() => {
    if (props.signRequestPDF) getPdgPageSize()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.signRequestPDF])

  useEffect(() => {
    if (pad.current) {
      // updateDimensions()
      setTimeout(() => {
        pad.current.clear()
        setClicAvailable(false)
        if (!props.baseSign) {
          setNamesInCanvas(props.tokenUserNames, props.tokenUserLastnames)
        } else {
          if (cleanInputsRef.current) cleanInputsRef.current()
        }
      }, 250)
    }
  }, [changedOrientation, hasChanged])

  useEffect(() => {
    if (
      props.visibleAccept &&
      !props.showLoadingRequesting &&
      props.currentSignaturetype.id ===
      Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) &&
      step === 'sign' && (props.currentUser ? (props.currentUser.proofOfLife ? checkedTerms : true) : false)
    ) {
      // updateDimensions()
      setTimeout(() => {
        if (!props.baseSign) {
          setNamesInCanvas(props.tokenUserNames, props.tokenUserLastnames)
        }
      }, 100)
    }
  }, [
    props.currentSignaturetype.id,
    props.showLoadingRequesting,
    props.tokenUserLastnames,
    props.tokenUserNames,
    props.visibleAccept,
    step,
    checkedTerms
  ])

  const onRender = (params) => {
    const importPDFCanvas = document.querySelector(
      `.import-pdf-page-${pageNumber} canvas`
    )
    const pdfAsImageSrc = importPDFCanvas.toDataURL()
    setTempImgPages(pdfAsImageSrc)
    setTempDimentions({ width: params.width, height: params.height })
  }

  const validateNip = async (cleanInputs) => {
    setShowLoading(true)
    setClicAvailable(false)
    let validNip = await props.validateNip(nip, setNip)
    if (validNip) {
      setShowLoading(false)
      setTimeout(async () => {
        let imageProperties = await setImageInCanvas(signatureImg)
        setScale(SignatureUtil.getScale(imageProperties.width, imageProperties.height))
        setClicAvailable(true)
      }, 100)
    } else {
      if (cleanInputs) cleanInputs()
      setShowLoading(false)
      setClicAvailable(false)
    }
  }

  const isPhone = useMediaQuery('(max-width:500px)')
  if (isMobile) greyText = 'dialogAcceptSignature.noticeCreateSignAutografaMobile'

  const instructions = [
    <>
      <strong>
        {t("dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.consent.title")}
      </strong>
      : {t("dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.consent.text")}
    </>
    ,
    <>
      <strong>
        {t("dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.camera.title")}
      </strong>
      : {t("dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.camera.text")}
    </>
    ,
    <>
      <strong>
        {t("dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.signature.title")}
      </strong>
      : {t("dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.signature.text")}<strong> "{t('signatureBaseAutograph.btn.capture')}"</strong> {t("dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.signature.text2")}
    </>
  ]

  const proofOfLifeActive = props.currentUser && props.currentUser.proofOfLife;
  return (
    <div>
      {/* <img src={signatureImg} /> */}
      {props?.signatureRequest?.signRequest?.signRequestStatus?.id ===
        Number(process.env.REACT_APP_SIGN_REQUEST_STATUS_PENDING) ? (
        <div className={(step === 'sign' && props.currentUser && props.currentUser.proofOfLife) ? isMobile ? 'dialogContent-proofOfLifeMobile' : 'dialogContent-proofOfLife' : 'dialogContent'}>
          {props.visibleAccept &&
            !props.showLoadingRequesting &&
            props.currentSignaturetype.id ===
            Number(process.env.REACT_APP_SIGNATURE_TYPE_AUTOGRAFA) && (
              <InteractiveDialog
                title={title || t(`dialogAcceptSignature.titleAcceptSignRequest.${props.currentSignaturetype.id}`)}
                onClose={() => {
                  if (props.currentUser.proofOfLife) {
                    setShowAuthorization(false)
                    setCheckedTerms(false)
                    cancelRecording()
                  }
                  setNip('')
                  props.onDeleteDataAccept()
                }}
                dialogSize='M'
                className={props.currentUser.proofOfLife && step === 'instructions' ? 'dialogContent-proofOfLife' : 'dialog-signature'}
              >
                {!proofOfLifeActive &&
                  <div
                    ref={greyTextRef}
                    style={{
                      // maxWidth: `645px`,
                      height: 'auto',
                      // maxWidth: '632px',
                      // backgroundColor: '#DEDEDE',
                      display: 'flex',
                      justifyContent: 'center',
                      position: isPhone && step !== 'sign' ? 'fixed' : '',
                      // top: 0,
                      zIndex: 1,
                    }}
                  >
                    <div style={{ padding: '15px 35px 15px 35px', boxSizing: 'border-box', backgroundColor: '#DEDEDE', width: isMobile ? '95%' : '100%' }}>
                      <p
                        style={{
                          margin: '0px',
                          fontFamily: 'Quicksand, sans-serif',
                          // paddingBottom: '10px',
                        }}
                      >
                        {t(greyText)}
                      </p>{' '}
                      {(greyText ===
                        'dialogAcceptSignature.noticeCreateSignAutografa' && !props.baseSign) && (
                          <p
                            style={{
                              margin: '0px',
                              fontFamily: 'Quicksand, sans-serif',
                            }}
                          >
                            {t('dialogAcceptSignature.noticeCreateSignAutografa2')}
                          </p>
                        )}
                    </div>
                  </div>}
                <div
                  className={proofOfLifeActive && 'dialog-all-height'}
                >
                  <Form
                    style={{ margin: '0px' }}
                    onSubmit={props.onSubmit}
                    allowSubmit={true}
                    className='formCustomSignature'
                    valid={true}
                    touched={true}
                    visited={true}
                    render={() => {
                      return (
                        <FormElement
                          className={proofOfLifeActive && 'dialog-all-height'}
                          style={{
                            maxWidth: '450px !important',
                            width: '100%',
                            margin: 'auto',
                          }}
                        >
                          <div
                            className={proofOfLifeActive && 'dialog-all-height'}
                          >
                            {step === 'sign' && (
                              <div style={{ display: "flex", flexDirection: "column" }}>
                                {proofOfLifeActive &&
                                  <>
                                    {showAuthorization ? <>
                                      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                                        <span>{`${t("dialogAcceptSignature.authorization.pt1")}`} <strong>{t("dialogAcceptSignature.authorization.a3cloud")}</strong> {t("dialogAcceptSignature.authorization.pt2")} <strong>{t("dialogAcceptSignature.authorization.govodigital")}</strong> {t("dialogAcceptSignature.authorization.pt3")}</span>
                                        <span>{t('dialogAcceptSignature.authorization.pt4')}</span>
                                        <span>{t('dialogAcceptSignature.authorization.pt5')} <strong>{t('dialogAcceptSignature.authorization.law')}</strong> {t('dialogAcceptSignature.authorization.pt6')} <strong>{t('simpleFooter.noticeOfprivacy')}</strong> {t('dialogAcceptSignature.authorization.pt7')} <a target='_blank' href={process.env.REACT_APP_REDIRECT_URI}>{process.env.REACT_APP_REDIRECT_URI}</a></span>
                                        <span>{t('dialogAcceptSignature.authorization.pt8')}</span>
                                      </div>
                                    </>
                                      :
                                      <>
                                        <InstructionsPure instructions={instructions} />
                                        <CheckBoxHLPure
                                          valueCheckBox={checkedTerms}
                                          onChangeHandler={/** @type {(e: React.ChangeEvent<HTMLInputElement>) => void} */((e) => {
                                            cancelRecording()
                                            setCheckedTerms(e.target.checked)
                                          })}
                                          labelCheckBox={
                                            <span>
                                              {t('dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.consent.checkboxLabel.pt1')} <span onClick={() => {
                                                // setShowInstructions(false)
                                                setShowAuthorization(true)
                                                setTitle(t('dialogAcceptSignature.authorization.dialog.title'))
                                              }} style={{ textDecoration: 'underline', fontWeight: "bold", cursor: "pointer" }}>{t('dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.consent.checkboxLabel.pt2')}</span> {t('dialogAcceptSignature.noticeCreateSignAutografa.instructionsText.consent.checkboxLabel.pt3')}
                                            </span>
                                          }
                                        />
                                      </>
                                    }
                                  </>
                                }
                                <div className={proofOfLifeActive ? 'canvas-draw-proofOfLife' : 'canvas-draw'}>
                                  {(checkedTerms && !showAuthorization) &&
                                    <>
                                      {proofOfLifeActive &&
                                        <div className='dialogAcceptSignatureAutografaCustom-face'>
                                          <FaceRecognition
                                            setImageData={setImageData}
                                            videoRefProp={videoRef}
                                            setRecordingStatus={setStatus}
                                            recordingStatus={status}
                                            startRecording={startRecording}
                                            setStream={setStream}
                                            setFaceState={setProofOfLifeValid}
                                            canvasRef={canvasRef}
                                          />
                                        </div>
                                      }
                                      <CanvasDraw
                                        ref={pad}
                                        loadTimeOffset={0}
                                        lazyRadius={2}
                                        brushRadius={2}
                                        brushColor={'#000'}
                                        catenaryColor={'#0a0302'}
                                        gridColor={'rgba(150,150,150,0.17)'}
                                        hideGrid={true}
                                        canvasWidth={width}
                                        canvasHeight={height}
                                        disabled={!proofOfLifeValid} //VARIABLE DE FUNCION AQUI
                                        immediateLoading={true}
                                        hideInterface={false}
                                      // onChange={() => !proofOfLifeActive && setClicAvailable(true)}
                                      />
                                    </>
                                  }
                                  {((!proofOfLifeActive)) ?
                                    !showLoading ?
                                      (<CanvasDraw
                                        ref={pad}
                                        loadTimeOffset={0}
                                        lazyRadius={2}
                                        brushRadius={2}
                                        brushColor={'#000'}
                                        catenaryColor={'#0a0302'}
                                        gridColor={'rgba(150,150,150,0.17)'}
                                        hideGrid={true}
                                        canvasWidth={width}
                                        canvasHeight={height}
                                        disabled={(props.baseSign ? true : false)} //VARIABLE DE FUNCION AQUI
                                        immediateLoading={true}
                                        hideInterface={false}
                                        onChange={() => setClicAvailable(true)}
                                      />) : <SimpleLoading />
                                    : null
                                  }
                                </div>
                              </div>
                            )}
                            {step === 'location' && (
                              <div
                                style={{
                                  width: pagesSize[0].width + 16,
                                  height: pagesSize[0].height + 16,
                                }}
                              >
                                <div
                                  className={`button-dialog-accept button-dialog-accept-size icons-bars`}
                                >
                                  <span
                                    class='k-icon k-i-arrow-double-60-left icon-bar'
                                    onClick={() => {
                                      changePageSign(1)
                                    }}
                                  ></span>
                                  <span
                                    class='k-icon k-i-arrow-60-left icon-bar'
                                    // onClick={previousPage}
                                    onClick={previousSign}
                                  ></span>
                                  <div
                                    className='pagec'
                                    style={{
                                      color: '#427FBA',
                                      textAlign: 'center',
                                      fontWeight: 'bold',
                                      marginTop: 'auto',
                                      marginBottom: 'auto',
                                      padding: '0px 5px'
                                    }}
                                  >
                                    {t('dialogAcceptSignature.paginationName')}
                                    {/* Página */}
                                    <input
                                      style={{
                                        width: '32px',
                                        marginLeft: '4px',
                                        marginRight: '3px',
                                      }}
                                      type='text'
                                      value={sign}
                                      onKeyDown={e => keyDown(e)}
                                    />
                                    {t('documentDisplay.of')}{' '}
                                    {coordinates.length || '--'}
                                    {/* de {numPages || '--'} */}
                                  </div>
                                  <span
                                    class='k-icon k-i-arrow-60-right icon-bar'
                                    onClick={nextSign}
                                  // onClick={nextPage}
                                  ></span>
                                  <span
                                    class='k-icon k-i-arrow-double-60-right icon-bar'
                                    onClick={() => {
                                      changePageSign(coordinates.length)
                                    }}
                                  ></span>
                                </div>
                                {/* {pagesImgs.map((item, index) => (
                                  <React.Fragment key={String(index)}> */}
                                <div
                                  style={
                                    pageNumber
                                      ? {}
                                      : { display: 'none' }
                                  }
                                >
                                  {tempImgPages &&
                                    <P5Contianer
                                      {...props}
                                      currentUser={props.currentUser.name}
                                      base64Img={tempImgPages}
                                      widthImg={tempDimentions.width}
                                      heightImg={tempDimentions.height}
                                      imgSignature={imgSignature}
                                      coordinates={coordinates}
                                      signatures={props.signatures}
                                      currentPage={pageNumber}
                                      insertSign={(data) => {
                                        setCurrentSign(data)
                                        setSign(data.index + 1)
                                        setStep(props.currentUser.proofOfLife ? 'instructions' : 'sign')
                                        // setStep('sign')
                                        setClicAvailable(false)
                                      }}
                                      widthImgSignature={widthImgSignature}
                                      heightImgSignature={heightImgSignature}
                                      pageNumber={pageNumber}
                                      save={async (params) => {
                                        // let temp = {
                                        //   ...params,
                                        //   page: index + 1,
                                        // }
                                        // props.setSignatureImgeData(temp)
                                        await props.setAllSignatures(params)
                                        props.onSubmit()
                                      }}
                                      activeOnSubit={values.activeOnSubit}
                                      signatureData={values.signatureData}
                                      dispatchValues={dispatchValues}
                                      back={() => {
                                        setTimeout(() => {
                                          props.toggleDialogAccept()
                                        }, 100)
                                        // setStep('sign')
                                        // setClicAvailable(false)
                                      }}
                                      cancel={() => {
                                        setStep('sign')
                                        props.onDeleteDataAccept()
                                        setClicAvailable(false)
                                      }}
                                      isMobile={false}
                                      gotToEnd={gotToEnd}
                                      isPhone={isPhone}
                                    />
                                  }
                                </div>
                              </div>
                            )}
                            {step === 'sign' && (
                              <div
                                className={`${props.baseSign && 'button-dialog-accept-baseSign'
                                  } button-dialog-accept-size ${step === 'location' &&
                                  'button-on-custom-signature'
                                  }`}
                              >
                                {(props.baseSign && !props.currentUser.proofOfLife) &&
                                  <div style={{ marginTop: '10px' }}>
                                    <ValidationCodePure
                                      data={nip}
                                      setData={setNip}
                                      validationLength={4}
                                      title={t('dialogAcceptSignature.enter.nip')}
                                      hide={true}
                                      autoFocusNIP={true}
                                      handleValidateNip={validateNip}
                                      cleanInputsRef={cleanInputsRef}
                                    />
                                  </div>
                                }
                                <div
                                  item
                                  xs={12}
                                  lg={12}
                                  md={12}
                                  sm={12}
                                  es={12}
                                  className={`sign-btn ${props.currentUser.proofOfLife ? 'buttons-faceRecognition-display' : 'buttons-sign-display'}`}
                                >
                                  <ButtonHLPure
                                    nameBtn={t('button.return')}
                                    onClickBtn={() => {
                                      if (showAuthorization) {
                                        setTitle(t('dialogAcceptSignature.proof-sign.dialog.title'))
                                        setShowAuthorization(false)
                                        return
                                      }
                                      if (props.currentUser.proofOfLife) {
                                        cancelRecording()
                                        props.toggleDialogAccept()
                                      } else {
                                        if (props.noRenderSign) {
                                          props.toggleDialogAccept()
                                          setNip('')
                                        } else {
                                          setStep(props.currentUser.proofOfLife ? 'instructions' : 'location')
                                          setNip('')
                                        }
                                      }
                                    }
                                    }
                                  />


                                  {/* Btn clean */}
                                  {
                                    (proofOfLifeActive
                                      ? checkedTerms
                                      : !props.baseSign) && (
                                      <ButtonHLPure
                                        nameBtn={t('dialogAcceptSignature.clean')}
                                        onClickBtn={() => {
                                          setClicAvailable(false)
                                          props.setImgSignature(null)
                                          pad.current.clear()
                                          // updateDimensions()
                                          setTimeout(() => {
                                            setNamesInCanvas(props.tokenUserNames, props.tokenUserLastnames)
                                          }, 0)
                                          setTimeout(
                                            () =>
                                              props.setImgSignature(saveImage()),
                                            10
                                          )
                                        }}
                                      />
                                    )
                                  }
                                  {(proofOfLifeActive ? checkedTerms : true) &&
                                    <ButtonHLPure
                                      disabled={!props.currentUser.proofOfLife ? (!clicAvailable || (props.baseSign && !(nip.length === 4))) : !proofOfLifeValid}
                                      nameBtn={t('dialogAcceptSignature.captureSignature')}
                                      primary
                                      onClickBtn={async () => {
                                        const stampTime = await getStampTimeAndTimezone()
                                        let recordedBlob = null
                                        if (props.currentUser.proofOfLife) {
                                          recordedBlob = await stopRecording()
                                        }
                                        const bufferVideo = recordedBlob
                                        if (stampTime === false) {
                                          props.onErrorTimeStamp()
                                          return false
                                        }

                                        adjustYCoordinates(changedOrientation)

                                        setTextInCanvas(
                                          yPositionCanvas.y3,
                                          `${stampTime}`,
                                          true
                                        )

                                        let {
                                          newImg,
                                          imageWidth,
                                          imageHeight,
                                        } = saveImage(props.currentUser.proofOfLife)
                                        setImgSignature(newImg)

                                        let fileSignImage = null
                                        await fetch(newImg)
                                          .then((res) => res.blob())
                                          .then((blob) => {
                                            const file = new File(
                                              [blob],
                                              'signature.png'
                                            )
                                            fileSignImage = file
                                          })

                                        props.toggleLoadingRequesting(true)
                                        let allSignatures = props.signatures.map((signature, index) => {
                                          const item = coordinates[index]
                                          const heightImg = pagesSize[0].height
                                          const hRect = heightImgSignature / 3
                                          return {
                                            ...signature,
                                            x: item.x,
                                            y: -item.y + heightImg - hRect,
                                            width: 208,
                                            height: 100,
                                            index: index + 1,
                                            page: item.page,
                                            heightImg: heightImg,
                                            fileSignImage,
                                            isMobile: isMobile,
                                            imgSignature: newImg,
                                            fileName: `sign${index + 1}`
                                          }
                                        }
                                        )
                                        props.setAllSignatures(allSignatures)
                                        setWasChanged(true)
                                        props.setImgSignature({
                                          imgSignature: newImg,
                                          imageWidth,
                                          imageHeight,
                                        })
                                        setWidthImgSignature(imageWidth)
                                        setHeightImgSignature(imageHeight)
                                        // setSign(sign)
                                        // if (isMobile) {
                                        //   setShowSignatureCanvas(true)
                                        // } else 
                                        // setStep('location')
                                        props.onSubmit(nip, setNip, stampTime, bufferVideo, imageData)
                                      }}
                                    />
                                  }
                                </div>
                              </div>
                            )}
                          </div>
                        </FormElement>
                      )
                    }}
                  />
                </div>
              </InteractiveDialog>
            )}
        </div>
      ) : null}
      <div style={{ display: 'none' }}>
        <Document
          file={props.result ?? pdfFile}
          onLoadSuccess={onDocumentLoadSuccess}
          onLoadError={e => console.log({ e })}
        >
          <Page
            className={`import-pdf-page-${pageNumber}`}
            pageNumber={pageNumber}
            onRenderSuccess={(params) => onRender(params)}
          />
        </Document>
      </div>
    </div>
  )
}

export { DialogAcceptSignatureAutografaCustom as default }